import FeedVirtualized from '../../components2/Feed/FeedVirtualized';

import {
    fetchHomeFeed,
    HOME_FEED_FOR_YOU_KEY
} from "../../../api/public-voissa/home-feed";
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import { USER_CURRENT_KEY } from '../../../api/public-voissa/users';

const HomeFeedForYou = ()=>{
    const queryClient = useQueryClient();
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const infiniteQuery = useInfiniteQuery(
        [HOME_FEED_FOR_YOU_KEY],
        ({pageParam}) => fetchHomeFeed('for-you', dataCurrentUser, {dateIndex : pageParam}),
        {
            staleTime : (60 * 60 * 1),
            getNextPageParam: (lastPage) => {
                return lastPage.more && lastPage.lastDateIndex;
            }
        }
    );
    return (
        <FeedVirtualized
            emptyDataContent={<div><div style={{fontSize:'18px'}}>Votre aventure commence ici !</div><br/><br/><b>Suivez</b> vos premiers comptes et laissez-vous surprendre par la diversité et le talent de notre communauté.</div>}
            infiniteQuery={infiniteQuery}
        />
    )
}

export default HomeFeedForYou;